<mat-toolbar class="subtitulo">Histórico do Beneficiário</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">           

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex= "200px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <input matInput name= "dataInicio" required
                            [matDatepicker]="dataInicio" 
                            placeholder="Data início" 
                            [(ngModel)]="filtro.dataInicioInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicio></mat-datepicker>
                </mat-form-field>
            
                <mat-form-field fxFlex= "200px" >
                    <input matInput name="dataFim" required
                            [matDatepicker]="dataFim" 
                            placeholder="Data fim" 
                            [(ngModel)]="filtro.dataFimInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                    <mat-datepicker #dataFim></mat-datepicker>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div ngModelGroup="comboCpfBeneficiario" fxFlex="250px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <combo-pesquisavel #comboCpfBeneficiario 
                                       nome="cpf" 
                                       [itens]="comboCpf" 
                                       itemDescricao="cpf"
                                       itemId="id"
                                       [showDisplayId]="false" 
                                       [obrigatorio]="false"
                                       label="CPF"
                                       placeholder="CPF"
                                       [(valor)]="filtro.cpfAluno">
                    </combo-pesquisavel>
                </div> 
                <div ngModelGroup="comboBeneficiario" fxFlex="34" fxLayoutGap="20px">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="false" 
                                        [selecionado]="filtro.beneficiario"
                                        label="Nome Completo"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>                
            </div>

            <div>
                <div style="margin-top: 25px;">
                    <span style="font-weight: bold;">Imprimir informações:</span>
            
                    <mat-checkbox 
                        color="primary" 
                        name="tipoPedagogicoName" 
                        [(ngModel)]="tipoPedagogicoSelecionado" 
                        class="custom-checkbox"
                        style="margin-left: 15px; margin-right: 30px;">
                        Pedagógico
                    </mat-checkbox>
            
                    <mat-checkbox 
                        *ngIf="verificaAcesso(getModulos().SAP)"  
                        color="primary" 
                        name="tipoPsicossocialName" 
                        [(ngModel)]="tipoPsicossocialSelecionado"
                        class="custom-checkbox">
                        Psicossocial
                    </mat-checkbox>
                </div>
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="150px" (click)="getRelatorio(MIMETYPE_PDF)" 
                        [ngStyle]="{'background-color' : formulario.valid ? 'green' : ''}" 
                        style="color: white;" 
                        [fxHide]="!mostrarTabela"
                        [disabled]="formulario.invalid">
                    GERAR PDF
                </button>

                <button mat-raised-button fxFlex="150px" 
                        (click)="getRelatorio(MIMETYPE_EXCEL)" 
                        [ngStyle]="{'background-color' : formulario.valid ? 'green' : ''}" 
                        style="color: white;" 
                        [fxHide]="!mostrarTabela"
                        [disabled]="formulario.invalid">
                    GERAR EXCEL
                </button>

                <button mat-raised-button fxFlex="150px" (click)="consultar()" 
                        [disabled]="formulario.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="150px" style="padding-right: 20px" (click)="limpar()">
                    LIMPAR
                </button>
            </div>            
        </form>

        <div [hidden]="!mostrarTabela" style="margin-top: 20px;">
            <mat-paginator #paginator [pageSizeOptions]="[50, 100, 150, 200, 300]" showFirstLastButtons></mat-paginator>
        </div>
        <table [fxHide]="!mostrarTabela" 
                matSort matSortDisableClear mat-table [dataSource]="dataSource">
                
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 20px">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="matricula" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 50px">Matrícula</th>
                <td mat-cell *matCellDef="let element"> {{element.matricula }} </td>
            </ng-container>

            <ng-container matColumnDef="beneficiario" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Beneficiário</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeBeneficiario }} </td>
            </ng-container>          

            <ng-container matColumnDef="dataEntrada">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80px"> Data Entrada</th>
                <td mat-cell *matCellDef="let element"> {{element.dataEntrada | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="dataDesligamento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80px"> Data Desligamento</th>
                <td mat-cell *matCellDef="let element"> {{element.dataDesligamento | dataSimples }} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator (page)="handlePageBottom($event)" 
                            [pageSize]="paginator.pageSize"
                            [pageIndex]="paginator.pageIndex" 
                            [length]="paginator.length"
                            [pageSizeOptions]="paginator.pageSizeOptions">
            </mat-paginator>
        </div>        
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px"
                [fxHide]="mostrarTabela" >
            {{msg}}
        </div>       

    </div>
</div>




